import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function Copyright(props) {
  return (
    <Typography
      variant="caption"
      sx={{
        color: 'text.secondary',
        display: 'block',
        textAlign: 'center',
        mt: 4,
        userSelect: 'none',
      }}
    >
      © {new Date().getFullYear()}{' '}
      <Link
        href="https://algorleap.com"
        target="_blank"
        rel="noopener"
        color="text.primary"
        underline="none"
        sx={{
          fontWeight: 700,
          transition: 'color 0.2s ease-in-out',
          '&:hover': {
            color: 'primary.main',
          },
          '&:focus': {
            outline: 'none',
          },
        }}
      >
        Algor Leap Solutions
      </Link>
      . All rights reserved.
    </Typography>
  );
}
